class EduZohoForm extends HTMLElement {
  constructor() {
    super();

    this.handleReset = this.handleReset.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  connectedCallback() {
    this.form = this.querySelector('form');
    this.submitButton = this.form?.querySelector('[type="submit"]');
    this.successMessage = this.querySelector('[data-edu-form-success]');
    this.errorMessage = this.querySelector('[data-edu-form-error]');

    if (!this.form || !this.submitButton) return;

    this.form.addEventListener('submit', this.handleSubmit);
    this.form.addEventListener('reset', this.handleReset);
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.handleSubmit);
    this.form?.removeEventListener('reset', this.handleReset);
  }

  handleReset() {
    this.hideMessages();
  }

  async handleSubmit(event) {
    event.preventDefault();

    if (this.form.getAttribute('aria-busy') === 'true') return;

    this.hideMessages();

    if (!this.form.reportValidity()) return;

    this.setSubmitting(true);

    const formData = new FormData(this.form);
    const urlParameters = new URLSearchParams(window.location.search);

    if (urlParameters.get('service') === 'smarturl') {
      formData.set('service', 'smarturl');
    }

    try {
      if (window._wfa_track?.wfa_submit) {
        window._wfa_track.wfa_submit(event);
      }

      const response = await fetch(this.form.action, {
        method: 'POST',
        body: formData,
        credentials: 'omit',
        headers: {
          Accept: 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`Zoho form request failed with status ${response.status}`);
      }

      const responseType = response.headers.get('content-type') || '';
      const responseData = responseType.includes('application/json')
        ? await response.json().catch(() => null)
        : null;
      const successText = responseData?.actionvalue || this.dataset.successMessage;

      this.form.reset();
      this.showMessage(this.successMessage, successText);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'edu_form_submit',
        form_type: 'education_program',
      });
    } catch (error) {
      console.error('Unable to submit the education program form.', error);
      this.showMessage(this.errorMessage, this.dataset.errorMessage);
    } finally {
      this.setSubmitting(false);
    }
  }

  hideMessages() {
    for (const message of [this.successMessage, this.errorMessage]) {
      if (!message) continue;

      message.hidden = true;
      message.textContent = '';
    }
  }

  showMessage(element, text) {
    if (!element) return;

    element.textContent = text;
    element.hidden = false;
    element.focus({ preventScroll: false });
  }

  setSubmitting(isSubmitting) {
    this.form?.setAttribute('aria-busy', String(isSubmitting));
    this.submitButton.disabled = isSubmitting;
  }
}

if (!customElements.get('edu-zoho-form')) {
  customElements.define('edu-zoho-form', EduZohoForm);
}
